import { useState, useEffect, } from "react";
import {
    TextField,
    ChoiceList,
    Icon,
    Button,
    Modal,
    Spinner,
} from "@shopify/polaris";
import { DuplicateIcon } from "@shopify/polaris-icons";
import "./index.scss";
import {
    reqGetKeywordsData,
    reqSaveCategory,
    reqAddToKeywordCategory,
    reqAddOnPageKeyword,

} from "../../api/index";
import Langauge from "../../i18n/Language";
import cloneDeep from 'lodash-es/cloneDeep';
const t = Langauge;


const AddToSegments = (props) => {
    const {
        level,
        type,
        openState,
        keywordsSelData,

        show,
        toggleToast,
        handleCloseModal,
        handleResetAll,
        handleCallbackData,
        handleUpdCollect,

    } = props;

    const [segmentsList, setSegmentsList] = useState([]);  // Segments选项
    const [segmentsSelArr, setSegmentsSelArr] = useState([]);  // Segments筛选选项
    const [createSegmentState, setCreateSegmentState] = useState(true);  // 创建模式
    const [segmentVal, setSegmentVal] = useState("");  // seg文案
    const [createLoading, setCreateLoading] = useState(false);  // 创建loading
    const [saveLoading, setSaveLoading] = useState(false);  // 保存loading
    const [dataLoading, setDataLoading] = useState(false);  // loading
    const [userLevel, setUserLevel] = useState(1);

    // 获取关键词数据
    const getKeywordData = async (isCallBack = false) => {
        setDataLoading(true);
        const res = await reqGetKeywordsData();
        if (res.ack === 1) {
            let _t = res.data;
            let newSegmentsArr = (_t.category || []).map(i => {
                return {
                    id: i.id,
                    label: i.name,
                    value: i.id,
                    status: segmentsSelArr.includes(i.id) ? true : false,
                }
            })
            setSegmentsList(newSegmentsArr);
            setDataLoading(false);
        } else {
            // setTipBanner(res.msg);
        }

        if (isCallBack) {
            handleCallbackData(res);
        }
    }

    // 创建segmenet
    const handleCreateSegments = () => {
        let newList = cloneDeep(segmentsList);
        newList.push({
            id: 0,
            value: 0,
            label: segmentVal,
        })
        submitUpdSegments(newList);
    }

    // 提交数据
    const submitUpdSegments = async (data) => {
        setCreateLoading(true);
        let params = {
            category: data.map(d => {
                return {
                    id: d.id,
                    name: d.label
                }
            })
        };
        const res = await reqSaveCategory(params);
        if (res.ack === 1) {
            setSegmentVal("");
            setCreateSegmentState(true);
            setSegmentsList(data);
            getKeywordData(Boolean(type === "Keywords"));
        }
        setCreateLoading(false);
    }

    // 选择分类
    const handleSelectChange = (e) => {
        setSegmentsSelArr(e);
    }

    // 切换创建
    const handleCreateSegment = () => {
        setCreateSegmentState(!createSegmentState);
    }

    // 输入
    const handleSegmentValChange = (v) => {
        setSegmentVal(v)
    }

    // 失焦
    const blurSegmentChange = () => {
        if (!segmentVal) {
            setCreateSegmentState(true);
        }
    }

    // 保存分类选择
    const saveSegmentsSet = async () => {
        if (userLevel !== 3) {
            show(2);
        } else {
            setSaveLoading(true);
            let params = {
                category_ids: segmentsSelArr,
            };
            if (type === "Keywords") {
                params.keyword_ids = keywordsSelData;
            } else {
                params.keywords = keywordsSelData;
                params.from = type === "GoogleAnalytics" ? 5 : 4;
            }
            let res = {};
            if (type === "Keywords") {
                res = await reqAddToKeywordCategory(params);
            } else {
                res = await reqAddOnPageKeyword(params);
            }
            if (res.ack === 1) {
                toggleToast(t("Saved"))
                setCreateSegmentState(true);
                setSegmentVal("");
                setSegmentsSelArr([]);
                handleCloseModal();
                if (type === "Keywords") {
                    handleResetAll();
                } else {
                    if(type !== "GoogleAnalytics") {
                        handleUpdCollect();
                    }
                }
            } else {
                toggleToast(res.msg, true);
            }
            setSaveLoading(false);
        }
    }

    // 关闭添加分类
    const handleCloseAddSegments = () => {
        setCreateSegmentState(true);
        setSegmentVal("");
        setSegmentsSelArr([]);
        handleCloseModal();
    }

    useEffect(() => {
        if (openState) {
            getKeywordData();
        }
    }, [openState])

    useEffect(() => {
        setUserLevel(level);
    }, [level])

    const AddSegModal = <Modal
        open={openState}
        title={t("Add to categories")}
        primaryAction={{
            content: t("Save"),
            disabled: !createSegmentState || createLoading || dataLoading,
            loading: saveLoading,
            onAction: saveSegmentsSet
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                disabled: !createSegmentState || createLoading || saveLoading || dataLoading,
                onAction: handleCloseAddSegments
            }
        ]}
        onClose={handleCloseAddSegments}
    >
        <Modal.Section>
            <div className="segments_list">
                {
                    dataLoading ? <span><Spinner size="small" /></span> : <ChoiceList
                        title=""
                        titleHidden
                        allowMultiple
                        choices={segmentsList}
                        selected={segmentsSelArr || []}
                        onChange={handleSelectChange}
                    />
                }
            </div>
            <div className="opera_segment">
                {
                    createSegmentState ? <div className="create_segment flex_layout" onClick={handleCreateSegment}>
                        <span><Icon source={DuplicateIcon} tone="base" /></span>
                        <Button variant="plain">{t("Create new category")}</Button>
                    </div> : <div className="flex_layout">
                        <TextField
                            value={segmentVal}
                            onChange={handleSegmentValChange}
                            onBlur={blurSegmentChange}
                            focused={true}
                        />
                        <Button variant="primary" loading={createLoading} onClick={handleCreateSegments}>{t("Save")}</Button>
                    </div>
                }
            </div>
        </Modal.Section>
    </Modal>

    return AddSegModal;
}

export default AddToSegments;